
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplatesDialog extends Serenity.EntityDialog<WhatsAppTemplatesRow, any> {
        protected getFormKey() { return WhatsAppTemplatesForm.formKey; }
        protected getIdProperty() { return WhatsAppTemplatesRow.idProperty; }
        protected getLocalTextPrefix() { return WhatsAppTemplatesRow.localTextPrefix; }
        protected getNameProperty() { return WhatsAppTemplatesRow.nameProperty; }
        protected getService() { return WhatsAppTemplatesService.baseUrl; }
        protected getDeletePermission() { return WhatsAppTemplatesRow.deletePermission; }
        protected getInsertPermission() { return WhatsAppTemplatesRow.insertPermission; }
        protected getUpdatePermission() { return WhatsAppTemplatesRow.updatePermission; }

        protected form = new WhatsAppTemplatesForm(this.idPrefix);

    }
}